export const getValidUrlToLink = (url?: string): string | undefined => {
  if (!url) return undefined

  return url.includes('http://') || url.includes('https://') ? url : `//${url}`
}
